module.exports = __webpack_public_path__ + "hexagon.ff4991bc.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/hexagon.svg
// module id = RPir
// module chunks = 0